import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { VentaService } from '../../../services/venta/venta.service';
import { ConfigService } from '../../../services/config/config.service';

@Component({
  selector: 'app-cancelar-venta',
  templateUrl: './cancelar-venta.component.html',
  styleUrls: ['./cancelar-venta.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class CancelarVentaComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  idComprobante?: number;
  subtotal: number = 0;
  impuesto: number = 0;
  token: any = {};
  infoUser: any = {};
  infoEmpresa: Array<any> = [];
  ventaCancelar: any = {};
  listBuy: Array<any> = [];
  showBtn: boolean = true;

  constructor(private venta: VentaService,
    private message: MessageService,
    private config: ConfigService) { }

  ngOnInit(): void {
  }


  getDetalleVenta() {

    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");

    // falta obtener proveedor
    if ((this.idComprobante ?? 0) > 0) {
      this.load = true;
      this.venta.getDetalleVenta(this.token.token, (this.idComprobante ?? 0), this.infoEmpresa[0].idProveedor).subscribe({
        next: (response) => {
          //Información para obtener fecha y persona que realizo el registro
          this.ventaCancelar = response as Array<any>;
          this.load = false;
          const diffInMs: any = Math.abs(new Date(this.ventaCancelar.fechaRegistro).valueOf() - new Date().valueOf());
          if ((diffInMs / (1000 * 60 * 60 * 24)) > 1) {
            this.message.add({ severity: 'warn', summary: 'Información', detail: 'La fecha de la venta no es del dìa de hoy, por ende no es posible cancelar' });
            return;
          }
          if (this.ventaCancelar.idVentaEstado == 3) {
            let resp: any = this.ventaCancelar.detalleVenta as Array<any>;

            this.listBuy = resp.map((row: any) => {
              return {
                idProducto: row.idProductoNavigation.idProducto,
                descripcionCorta: row.idProductoNavigation.descripcionCorta,
                referencia: row.idProductoNavigation.referencia,
                unidadPresentacion: row.idProductoNavigation.unidadPresentacion,
                marca: row.idProductoNavigation.marca,
                cantidad: row.cantidad,
                impuesto: row.impuesto,
                precioProducto: {
                  precioPromocion: row.subtotal / row.cantidad,
                  precio: row.subtotal / row.cantidad
                }
              };
              // validar las cantidades 
            });
            this.getTotal();

          } else
            this.message.add({ severity: 'warn', summary: 'Información', detail: 'La venta relacionada no aplica para cancelación' });
        }, error: (error: HttpErrorResponse) => {
          this.load = false;
          this.config.handleError(error);
          this.message.add({ severity: 'warn', summary: 'Información', detail: 'No existe venta  bajo este número' });
        }
      });
    }
    else {
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'Favor relacione un número de venta' });
    }

  }

  getTotal() {
    this.subtotal = 0;
    this.impuesto = 0;
    this.listBuy.forEach((item) => {
      this.subtotal += (item.precioProducto.precioPromocion >
        item.precioProducto.precio ? item.precioProducto.precio : item.precioProducto.precioPromocion) * item.cantidad;
      this.impuesto += item.impuesto;
    })
  }

  setCancelar = () => {
    this.load = true;
    this.venta.setCancelar(this.token.token, { idVenta: this.idComprobante }).subscribe((reponse) => {
      this.message.add({ severity: 'success', summary: 'Información', detail: 'Proceso realizado' });
      this.showBtn = false;
      this.load = false;
    });
  }
  reload = () => {
    window.location.reload();
  }

  volver = () => {
    window.location.href = this.config.urlHome + "Login";
  }
}
